import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApeComponentV2 } from './ape/ape-v2.component';
import { GrossRevenueComponentV2 } from './gross-revenue/gross-revenue-v2.component';
import { PiasConventionComponentV2 } from './pias-convention/pias-convention-v2.component';
import { MdrtStatusComponentV2 } from './mdrt-status/mdrt-status-v2.component';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    ApeComponentV2,
    GrossRevenueComponentV2,
    PiasConventionComponentV2,
    MdrtStatusComponentV2
  ],
  exports: [
    ApeComponentV2,
    GrossRevenueComponentV2,
    PiasConventionComponentV2,
    MdrtStatusComponentV2
  ]
})
export class DashboardComponentsModuleV2 { }
